import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_CONTENT } from "../content";

const HomePageSeo = () => {
  const { seo, faqs } = SITE_CONTENT.pages.homePage;

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": ["Organization", "CateringService", "LocalBusiness"],
    "@id": "https://www.nawabicaterers.com/#organization",
    "name": "Nawabi Caterers",
    "url": "https://www.nawabicaterers.com/",
    "telephone": "+91-91502-99336",
    "email": "nawabicaterers.support@gmail.com",
    "priceRange": "₹₹",
    "description":
      "Nawabi Caterers is an outdoor catering brand from NonVeeFoods, specialising in non-vegetarian cuisine and biryani for weddings, corporate functions, parties, and family events across Tamil Nadu.",
    "sameAs": [
      "https://www.facebook.com/nawabicaterers",
      "https://www.instagram.com/nawabicaterers",
      "https://www.youtube.com/@NawabiCaterers"
    ],
    "parentOrganization": {
      "@type": "Organization",
      "name": "NonVeeFoods"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress":
        "544/1, Jagir Ammapalayam, Near Sona College, Junction Main Road",
      "addressLocality": "Salem",
      "addressRegion": "Tamil Nadu",
      "postalCode": "636005",
      "addressCountry": "IN"
    },
    "areaServed": [
      { "@type": "State", "name": "Tamil Nadu" },
      { "@type": "City", "name": "Salem" },
      { "@type": "City", "name": "Chennai" },
      { "@type": "City", "name": "Coimbatore" },
      { "@type": "City", "name": "Erode" },
      { "@type": "City", "name": "Madurai" },
      { "@type": "City", "name": "Trichy" },
      { "@type": "City", "name": "Namakkal" },
      { "@type": "City", "name": "Dharmapuri" },
      { "@type": "City", "name": "Krishnagiri" },
      { "@type": "City", "name": "Tirupur" },
      { "@type": "City", "name": "Vellore" },
      { "@type": "City", "name": "Thanjavur" },
      { "@type": "City", "name": "Tirunelveli" },
      { "@type": "City", "name": "Kumbakonam" },
      { "@type": "City", "name": "Hosur" },
      { "@type": "City", "name": "Ooty" }
    ],
    "servesCuisine": ["Non-Vegetarian", "Biryani", "Indian"],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "3",
      "bestRating": "5",
      "worstRating": "1"
    },
    "review": [
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Anand & Divya"
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "reviewBody":
          "We booked Nawabi Caterers for our wedding reception in Coimbatore with over 700 guests. The mutton biryani was exceptional—cooked fresh right at the venue and served piping hot to every table. Their team managed the outdoor setup effortlessly, and our guests are still raving about the starters."
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Praveen K."
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "reviewBody":
          "Organized a corporate offsite in Salem, and Nawabi Caterers handled the entire lunch spread. They were punctual, extremely professional, and the non-veg curry and biryani setup suited our corporate environment perfectly. They made the whole process completely hassle-free."
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Meenakshi Sundaram"
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "reviewBody":
          "We needed non-veg catering for a housewarming function in Chennai for 120 guests. Nawabi Caterers customized the entire menu around our family's preferences, from the chicken starters to the desserts. Everything was prepared fresh on site, perfectly spiced, and served with great care."
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Catering Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Wedding Catering",
            "description":
              "Multi-course non-veg and biryani menu setups, cooking on site, and event coordination for weddings and receptions."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Non-Veg Catering",
            "description":
              "Specialized menus built around chicken and mutton dishes, gravies, and rice varieties."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Biryani Catering",
            "description":
              "Event-sized biryani preparation served hot with complementary side dishes."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Corporate Catering",
            "description":
              "Dependable catering service for office meetings, launches, and staff gatherings."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Birthday & Party Catering",
            "description":
              "Customized spreads designed for small and mid-sized party functions."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Family & Religious Function Catering",
            "description":
              "Respectful and occasion-appropriate catering for housewarmings, naming ceremonies, and family events."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Large-Scale & Event Catering",
            "description":
              "High-volume outdoor catering for community gatherings, public functions, and large weddings."
          }
        }
      ]
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.items.map((faq) => ({
      "@type": "Question",
      "name": faq.q,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.a
      }
    }))
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords} />
      <meta name="robots" content="index, follow" />
      <meta name="google-site-verification" content="n4A1wCQLHfRiUpKsfxTue7L9A0D-5wFSWnNuBZRJWmk" />
      <link rel="canonical" href={seo.canonical} />

      {/* Open Graph / Facebook Meta Tags */}
      <meta property="og:type" content={seo.og.type} />
      <meta property="og:url" content={seo.og.url} />
      <meta property="og:title" content={seo.og.title} />
      <meta property="og:description" content={seo.og.description} />
      <meta property="og:image" content={seo.og.image} />
      <meta property="og:image:alt" content={seo.og.imageAlt} />
      <meta property="og:site_name" content={seo.og.siteName} />
      <meta property="og:locale" content={seo.og.locale} />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.og.title} />
      <meta name="twitter:description" content={seo.og.description} />
      <meta name="twitter:image" content={seo.og.image} />

      {/* Structured Data (JSON-LD) */}
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
    </Helmet>
  );
};

export default HomePageSeo;

